export default __webpack_public_path__ + "static/media/bg-stream-a-3.25998138.png";